import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { Quote } from 'shared/types';
import { useSnackbar } from 'notistack';

export function useSendEmail() {
  const { userService } = useService();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<void, Error, [Quote, string]>(request => userService.sendNotification(...request), {
    onSuccess: (_, variables) => {
      const { assignedSalesRep } = variables[0];
      enqueueSnackbar(`A quote notification email has been sent to ${assignedSalesRep}`, {
        variant: 'success',
      });
    },
    onError: data => {
      enqueueSnackbar(data.message, { variant: 'error' });
    },
  });
}
